function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import CustomButtonIcon from './customButtonIcon.js';
import EVENTS from '../../../common/constants/events';
import { GalleryComponent } from '../../galleryComponent';

var CustomButton = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(CustomButton, _GalleryComponent);

  function CustomButton() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = CustomButton.prototype;

  _proto.render = function render() {
    var _this = this;

    var styleParams = this.props.styleParams;
    var buttonText = styleParams.customButtonText || 'Click here';
    return React.createElement("div", {
      className: "custom-button-wrapper",
      style: {
        justifyContent: styleParams.galleryHorizontalAlign,
        zIndex: 17
      }
    }, this.props.small ? React.createElement(CustomButtonIcon, null) : React.createElement("button", {
      "data-hook": "custom-button-button",
      onClick: function onClick() {
        return _this.props.actions.eventsListener(EVENTS.BUY_NOW_CLICKED, _this.props);
      },
      tabIndex: -1
    }, buttonText, React.createElement("div", {
      className: "overlay"
    })));
  };

  return CustomButton;
}(GalleryComponent);

export { CustomButton as default };